import { render, staticRenderFns } from "./bill-of-materials-bulk-update.vue?vue&type=template&id=aaa4af68"
import script from "./bill-of-materials-bulk-update.vue?vue&type=script&lang=js"
export * from "./bill-of-materials-bulk-update.vue?vue&type=script&lang=js"
import style0 from "./bill-of-materials-bulk-update.vue?vue&type=style&index=0&id=aaa4af68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports